import { render } from "./TabInformationsThird.vue?vue&type=template&id=3f354c0e&scoped=true"
import script from "./TabInformationsThird.vue?vue&type=script&lang=js"
export * from "./TabInformationsThird.vue?vue&type=script&lang=js"

import "./TabInformationsThird.vue?vue&type=style&index=0&id=3f354c0e&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f354c0e"]])

export default __exports__